import { TokenHelper } from '../../common/utils/TokenHelper';

const SecureLinkout = (element) => {
    if (!element) {
        return;
    }

    const links = element.querySelectorAll('.js-secure-linkout');

    if (!links) {
        return;
    }

    Array.prototype.forEach.call(links, link => {
        let targetLink = link.dataset.targetLink;
        const tokenKey = link.dataset.tokenParamName;

        targetLink = TokenHelper.append(targetLink, tokenKey);

        link.setAttribute('href', targetLink);
    });
};

export default SecureLinkout;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/SecureLinkout/index.js